import React, { useEffect } from 'react';
import { MaterialsHero } from '../components/materials/MaterialsHero';
import { MaterialOptionsSection } from '../components/materials/MaterialOptionsSection';
import { MaterialApplicationSection } from '../components/materials/MaterialApplicationSection';
import { MaterialObjectionsSection } from '../components/materials/MaterialObjectionsSection';
import { LongevitySection } from '../components/materials/LongevitySection';
import { ScopeImpactSection } from '../components/materials/ScopeImpactSection';
import { MaterialDecisionGuide } from '../components/materials/MaterialDecisionGuide';
import { MaterialsCTA } from '../components/materials/MaterialsCTA';
export function MaterialsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-background font-sans antialiased" data-id="element-1281">
      <main data-id="element-1282">
        <MaterialsHero data-id="element-1283" />
        <MaterialOptionsSection data-id="element-1284" />
        <MaterialApplicationSection data-id="element-1285" />
        <MaterialObjectionsSection data-id="element-1286" />
        <LongevitySection data-id="element-1287" />
        <ScopeImpactSection data-id="element-1288" />
        <MaterialDecisionGuide data-id="element-1289" />
        <MaterialsCTA data-id="element-1290" />
      </main>
    </div>;
}